import React from 'react';
import PropTypes from 'prop-types';
import { Handle, Position } from 'reactflow';
import { Box } from '@mui/material';
import { ReactComponent as DeleteOutlineIcon } from '../../../../assets/common-assets/trash.svg';
import { classes } from './utils';
import { globalClasses } from '../../utils/globalUtils';
import { lightPalette } from '../../../../theme';

const CustomNodeType = (props) => {
  const {
    data,
    id,
    nodes,
    setNodes,
    setEdges,
    handleIconSelect,
    selectedIcon,
    iconsMap,
    selectedNode,
    setSelectedIcon,
    selectedAccount,
    setIsDraggedChanged,
    isFlowRunning,
  } = props;

  const handleDelete = () => {
    setNodes((allNodes) => allNodes?.filter((allNode) => allNode.id !== id));
    setEdges((edges) =>
      edges.filter((edge) => edge.source !== id && edge.target !== id),
    );
    setSelectedIcon(null);
    setIsDraggedChanged(true);
  };

  let borderColor;
  const dataLabel = nodes?.find((node) => node?.id === id)?.data?.label;

  const isMicrosoftService = ['Outlook', 'OneDrive', 'SharePoint'].includes(
    dataLabel,
  );
  const isGoogleService = ['Gmail', 'GoogleDrive'].includes(dataLabel);
  const isOtherService = ['Odoo', 'Docutranscribe', 'Zoho'].includes(dataLabel);

  const account = selectedAccount?.[dataLabel] || {};
  const accessToken = account?.token;

  if (
    (accessToken && (isMicrosoftService || isGoogleService)) ||
    isOtherService
  ) {
    borderColor =
      selectedIcon?.id === id
        ? lightPalette.secondaryBlack.main
        : lightPalette.lunarBase.main;
  } else if (
    (!accessToken && isMicrosoftService) ||
    (!accessToken && isGoogleService)
  ) {
    borderColor = lightPalette.colorRed.main;
  } else {
    borderColor = lightPalette.lunarBase.main;
  }

  return (
    <>
      <Box display="flex" justifyContent="end" width="80px">
        <Box width={20} height={20}>
          {!isFlowRunning &&
            selectedIcon?.id === id &&
            selectedNode !== null && (
              <DeleteOutlineIcon
                onClick={handleDelete}
                className={`${classes.deleteForNode} ${globalClasses.cursorPointerClass} `}
              />
            )}
        </Box>
      </Box>

      <Box
        border={`1px solid ${borderColor}`}
        className={classes.customNodeBox}
        onClick={() => {
          if (!isFlowRunning) {
            handleIconSelect({ id, type: data.label });
          }
        }}
      >
        {iconsMap[data.label]}
        <Handle
          type="source"
          position={Position.Right}
          style={{
            background: lightPalette.primary.main,
            borderRadius: '50%',
            height: '6px',
            width: '6px',
            border: `1px solid ${lightPalette.primary.main}`,
          }}
          isConnectable={!isFlowRunning}
        />
        <Handle
          type="target"
          position={Position.Left}
          style={{
            background: lightPalette.primary.main,
            borderRadius: '50%',
            height: '6px',
            width: '6px',
            border: `1px solid ${lightPalette.primary.main}`,
          }}
          isConnectable={!isFlowRunning}
        />
      </Box>
    </>
  );
};

const nodeTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
  find: PropTypes.func.isRequired,
});

CustomNodeType.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  setNodes: PropTypes.func,
  setEdges: PropTypes.func,
  handleIconSelect: PropTypes.func,
  setSelectedIcon: PropTypes.func.isRequired,

  iconsMap: PropTypes.object,

  selectedNode: PropTypes.object,
  selectedIcon: PropTypes.string,
  nodes: nodeTypes.isRequired,
  selectedAccount: PropTypes.string.isRequired,
  setIsDraggedChanged: PropTypes.bool.isRequired,
  isFlowRunning: PropTypes.bool.isRequired,
};
CustomNodeType.defaultProps = {
  id: '',
  setNodes: null,
  setEdges: null,
  handleIconSelect: null,
  iconsMap: 0,
  selectedIcon: '',
  data: {},
  selectedNode: null,
};

export default CustomNodeType;
